import styled from "styled-components";
import { colors } from '../../../../styles/variables';

const handleTextSize = ({ size }) => {
    switch (size) {
        case 'extra-small':
            return `5rem`;
        case 'very-small':
            return `6rem`;
        case 'small':
            return `7rem`;
        case 'large':
            return `12rem`;
        case 'normal':
        default:
            return `10rem`;
    }
};

const secondTextStyles = `
    position: absolute;
    z-index: -1;
    left: 5px;
    top: 5px;
    -webkit-text-stroke: 0;
    -webkit-text-fill-color: ${colors.pinkAmour};
`;

export const STextBackgroundLayer = styled.span`
    ${secondTextStyles}
    bottom: ${({ prefix }) => prefix ? '1.5rem' : '0'};
`;

export const STextStrokeLayer = styled.div`
    position: relative;
    z-index: 1;
    display: inline-block;
    font-size: ${props => handleTextSize(props)};
    stroke: ${colors.berry};
    -webkit-text-stroke: 2px ${colors.berry};
    -webkit-text-fill-color: transparent;
    font-family: "Gilroy", sans-serif;
    font-weight: 800;
    line-height: 1;
    bottom: ${({ prefix }) => prefix ? '1.5rem' : '0'};

    .second-text {
        ${secondTextStyles}
    }
`;
